export function orderChatList(chatList) {
  let chatArr = Object.values(chatList);
  let finalRes = { ...chatList };

  let newList = chatArr.sort((a, b) => {
    if (a.lastMessage && b.lastMessage) {
      return b.lastMessage.timestamp - a.lastMessage.timestamp;
    } else {
      return 0;
    }
  });

  newList.forEach((item, index) => {
    finalRes[item.chatId] = {
      ...finalRes[item.chatId],
      index: index,
    };
  });

  return finalRes;
}

export function clearNoMessageList(chatList) {
  let finalRes = { ...chatList };

  for (let key in finalRes) {
    if (!finalRes[key]?.firstMessage?.content) {
      delete finalRes[key];
    }
  }

  return orderChatList(finalRes);
}
